

/**
ELENCO CAMPI NASCOSTI
---------------------
    
ctl00_cphNavigation_hidTimesheet_RowIds
    
    Il ctl00_cphNavigation_hidTimesheet_RowIds contiene la lista dei RowId disponibili per le pratiche
    Il formato del campo è: RowId01,RowId02,...,RowIdN

    Il valore RowId è composto come segue: 
             ppp_wwwwww_ssssss_cccc
    Esempio: 014_001521_004497_0001_20120124
    in cui
    ppp         Indica il profilo di provenienza 
    wwwwww      Indica l'Id dell'oggetto con profilo ppp
    ssssss      Indica l'Id della sottocartella (fascicolo per pratiche, ecc ecc)
    cccc        Indica l'Id dell'oggetto SYSActivityType
    
    Per ottenre gli altri parametri a partire da un RowId:
    
    TDId = RowId + <yyyymmdd>
    TXTId = 'txt_' + TDId
    Warning di riga = Left(RowId,19)+'0000'+'_Warning'
    Sum utilizzate = Left(RowId,22)+'0000'+'_sum_used'
    Sum inutilizzate = Left(RowId,22)+'0000'+'_sum_unused'
    
    Annullando il valore cccc ottengo i TDId delle celle di reipilogo per la pratica/fascicolo/giorno
    
    TDId_r = ppp_wwwwww_ssssss_0000_yyyyMMdd
    
    
    Per ottenere il RowId da un TDId
    RowId = Left(TDId,22)
    
    
ctl00_cphNavigation_hidTimesheet_Dates
    
    Il campo ctl00_cphNavigation_hidTimesheet_Dates contiene la lista delel date visibili per le pratiche nel formato yyyyMMdd
    
 **/

function UpdateTextDetected(Source) {
    /** Gestisce la modifica del valore di una cella
    
    Source  Indica l'id della casella di testo che viene modificata ed è in formato txt_<TDId>
    
    Imposta il formato della cella modificata ed aggiunge, se necessario, la data all'elenco contenuto nel campo nascosto di riga che mantiene l'elenco delle celle modificate
    
    
    **/
    var RowId = '';

    document.getElementById(Source).style.setProperty("background-color", "#F7DB78", "important");
    Source = Source.substring(4) //Rimuovo il "txt_" dal codice per ottenere cosi il TDId

    var CurrentDate = Right(Source, 8) //Ottengo la data modificata

    if (Left(Source, 3) == '144') {
        RowId = Left(Source, 22) //Ottengo il RowId dal TDId

    }

    else {
        RowId = Left(Source, 27) //Ottengo il RowId dal TDId

    }
    var Element = document.getElementById('hidMustSave_' + RowId); //Ottengo una reference all'elemento di riga nascosto che mantiene l'elenco delle date che vanno salvate 
    var MustUpdateElements = Element.value; //Ottengo la stringa contenente l'elenco delle date che vanno salvate

    if (MustUpdateElements.indexOf(CurrentDate) == -1) {   // La data modificata non è contenuta nell'elenco delle date da salvare
        if (MustUpdateElements == '')
        // L'elenco delle date da salvare è vuoto, lo riempio con la data in questione
        { Element.value = CurrentDate }
        else
        // L'elenco delle date da salvare NON è vuoto, aggiungo la data in questione
        { Element.value = Element.value + ',' + CurrentDate }
    }

}


function TestDataChanged(RowIdToCheck) {
    // Ritorna TRUE se i dati risultano modificati, FALSE se non lo sono
    // Se RowIdToCheck è vuoto allora vengono controllate tutte le righe, altrimenti solo la riga specificata da RowIdToCheck

    var asTest;
    var hidList;
    var AtLeastOneChange;
    var Counter;
    var Items;
    var TestValue;

    //Imposto il flag che indica alla fine della funzione se è stata trovata una cella modificata    
    AtLeastOneChange = false;

    if (RowIdToCheck != '') {
        //Acquisisco il valore della cella nascosta che contiene l'elenco delle date del RowId che indicano una modifica fatta
        if (document.getElementById('hidMustSave_' + RowIdToCheck) != null) {
            TestValue = document.getElementById('hidMustSave_' + RowIdToCheck).value;
            //Se la cella non è vuota vuol dire che un elemento della riga è stato modificato
            if (TestValue != '') { AtLeastOneChange = true; };

        }
        else { AtLeastOneChange = false; }
    }
    else {
        //Acquisisco il valore della cella nascosta che contiene l'elenco di tutti i RowId presenti sul foglio
        hidList = GetCTLSafeObjectById('ctl00_cphNavigation_hidTimesheet_RowIds').value;


        //trasformo il valore in un array
        asTest = hidList.split(',');
        //Acquisisco la lunghezza dell'array
        Items = asTest.length;

        for (Counter = 0; Counter < Items; Counter++) {
            //Ciclo negli elementi dell'array, quindi un RowId alla volta
            if (TestDataChanged(asTest[Counter]))//Ricorsione, chiamo me stesso fornendo però il parametro di riga
            {
                //La riga esaminata è stata modificata quindi esiste almeno un valore modificato
                AtLeastOneChange = true;
                //Interrompo il ciclo ponendo il contatore a fine ciclo
                Counter = Items;
            }
        }
    }
    //Se AtLeastOneChange è TRUE allora almeno un valore della tabella è stato modificato
    return AtLeastOneChange;
};



function TimeSheet(Id, RequestFrom) {

    /**
    Id      Stato   RequestFrom                     Descrizione
    ----------------------------------------------------------------------------------------------------------------
    100     OK      n.d.                            Caricamento iniziale di tutti i valori del timesheet
    101     OK      n.d.                            Imposta una nuova data
    102             codice del pulsante "salva"     Salva i dati di una riga                    
    103             n.d.                            Salva i dati di tutte le righe modificate
    ----------------------------------------------------------------------------------------------------------------
    
    **/

    var v000_Counter;
    var v000_Items;
    var v000_CounterSec;
    var v000_ItemsSec;
    var v000_TDId;
    var TestValue;

    /*
    if (document.getElementById('divTimesheetLoadingData') == null) { return false; };
    setTimeout("document.getElementById('divTimesheetLoadingData').innerHTML='<img src=Images/loading_data_long.gif />'", 50);
    */


    /** FUNZIONE 100 ********************************************************/
    if (Id == 100) { /** Caricamento iniziale di tutti i valori del timesheet **/
        Dispatcher(400, '', 'divTimesheetLoadingData');
    }


    /** FUNZIONE 101 ********************************************************/
    if (Id == 101) { // Cambio data: Verifico che non ci siano elementi modificati ed in caso chiedo conferma
        if (TestDataChanged('')) {
            if (!confirm('I dati modificati andranno persi. \n Si vuole proseguire?')) { return false; }
            else
            //Eseguo un postback ricaricando l'intera pagina
            { document.aspnetForm.submit(); }
        }
        else
        //Eseguo un postback ricaricando l'intera pagina
        { document.aspnetForm.submit(); }

        setTimeout("document.getElementById('divTimesheetLoadingData').innerHTML='';", 50);
    }


    /** FUNZIONE 102 ********************************************************/
    if (Id == 102) { // Salva i dati di una riga - RequestFrom indica il RowId
        if (TestDataChanged(RequestFrom))
        // La riga risulta effettivamente modificata
        {
            //Acquisisco l'elenco delle date che risultano modificate
            var v102_Dates = document.getElementById('hidMustSave_' + RequestFrom).value;

            //Trasformo l'elenco in un array
            var v102_asDates;
            var v102_TDIds;
            v102_asDates = v102_Dates.split(','); // Creao l'array con l'elenco delle date

            //Costruisco una nuova stringa composta da un elenco di TDId ottenuti dall'elenco delle date

            v000_Items = v102_asDates.length;
            v102_TDIds = '';

            for (v000_Counter = 0; v000_Counter < v000_Items; v000_Counter++)
            // Ciclo nell'elenco delle date da salvare
            {
                if (v102_TDIds != '') { v102_TDIds = v102_TDIds + ',' };

                v102_TDIds = v102_TDIds + RequestFrom + "_" + v102_asDates[v000_Counter] // Aggiungo il TDId calcolato al volo all'elenco dei TDId da salvare

            };

            //Chiamo la funzione 401 del dispatcher passando l'elenco dei TDId da salvare sul database
            setTimeout("Dispatcher(401,'" + v102_TDIds + "','divTimesheetLoadingData')", 200);

            //Il dispatcher dovrà annullare il valore modificato se il salvataggio andrà a buon fine
        }
        else {
            HideDispatcherExecute('divTimesheetLoadingData');
            return false;
        }
    }


    /** FUNZIONE 103 ********************************************************/
    if (Id == 103) { // Salva i dati di tutte le righe modificate

        //Acquisisco l'elenco dei RowId
        if (!confirm('I dati modificati verranno salvati.\nSi vuole proseguire?')) {
            setTimeout("document.getElementById('divTimesheetLoadingData').innerHTML=''", 50);
            return false;
        };

        var AtLeastOneModified=false;



        TestValue = GetCTLSafeObjectById('ctl00_cphNavigation_hidTimesheet_RowIds');

        var v103_RowIDs = TestValue.value;
        var v103_aRowIds = v103_RowIDs.split(',');

        v000_Items = v103_aRowIds.length;

        for (v000_Counter = 0; v000_Counter < v000_Items; v000_Counter++)
        // Ciclo tra tutti i RowId contenuti nel documento
        {
            if (TestDataChanged(v103_aRowIds[v000_Counter]))
            // la riga risulta modificata
            {
                AtLeastOneModified = true;

                TimeSheet(102, v103_aRowIds[v000_Counter]); //Chiamo la funzione del Timesheet che salva i dati di una riga
            }
        }



    }


    /** FINE FUNZIONE TimeSheet ********************************************************/
};